<template>
  <div class="filter-container">

    <v-row
      class="pl-1"
      justify="center"
    >
      <v-col
        cols="4"
        class="mb-0"
      >
        <h3 class="text-subtitle-2 font-weight-bold">
          {{title}}
        </h3>
      </v-col>

      <v-col class="pl-0 ml-1">
        <p
          class="text-caption mb-1"
          style="padding-top: 2px;"
        >{{value.length === 0 ? '(viser alle)' : '(' + value.length + ' valgt)'}}</p>
      </v-col>

    </v-row>

    <div>
      <filter-description
        :title="title"
        :show="showDescription"
        :description="options.description"
      />

      <template v-for="(checkbox, index) in options.optionsHelpText">
        <v-row
          class="pr-7"
          align="center"
          v-show="index <= 4 || showAll && index > 4"
          :key="checkbox.name"
        >
          <v-col
            cols="10"
            class="mb-0 pa-0 pl-3"
          >
            <v-checkbox
              class="pa-0 ma-0"
              hide-details
              v-model="value"
              :label="checkbox.name"
              :value="checkbox.name"
              @change="updateFilter"
            ></v-checkbox>
          </v-col>
          <v-spacer />
          <v-col
            justify="end"
            cols="1"
            class="mb-0 pa-0"
          >            
            <v-menu class="ma-2" style="z-index: 1000"
              open-on-hover rounded
              offset-x
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                >
                  <v-icon
                    small
                    dark
                  >mdi-information-outline</v-icon>
                </v-btn>
              </template>

              <div
                class="pa-2 elevation-2"
                style="max-width: 300px; background: white"
              >
                <h3 class="text-subtitle-2 font-weight-bold">
                  {{checkbox.name}}
                </h3>
                <p v-html="checkbox.infoText" class="text-caption"></p>
              </div>
            </v-menu>
          </v-col>

        </v-row>
      </template>

      <v-row class="ml-1 pt-2">
        <v-btn
          color="primary"
          text
          depressed
          outlined
          @click="showAll = !showAll"
        >{{showAll ? 'Vis færre' : 'Vis flere'}}</v-btn>
      </v-row>

    </div>
  </div>
</template>

<script>
import { FilterTitle } from "@/components/index";
import FilterDescription from "./FilterDescription";
import FilterSettings from "./FilterSettings";
import { mapActions } from "vuex";
import { getQueryStringForMultiselect, getQueryStringForMultiselectUsingLikeOperator } from "./utils.js"
import FilterCheckBox from './FilterCheckBox.vue';

export default {
  name: "FilterCheckboxGroup",
  data () {
    return {
      value: [],
      showDescription: false,
      showSettings: false,
      showAll: false
    };
  },
  components: { FilterTitle, FilterDescription, FilterSettings, FilterCheckBox },
  watch: {
    options: {
      handler: function () {
        this.value = this.options.currentValue ? this.options.currentValue : [];
        this.updateFilter(this.value);
      }, deep: true
    }
  },
  props: {
    title: String,
    helptext: String,
    checkboxes: Array,
    parameter: String,
    options: Object,
    show: Boolean,
    singleSelectOptions: {
      default: function () {
        return {
          value: {
            id: "equal",
            name: "Er lik",
            operator: ""
          },
          options: [
            {
              id: "equal",
              name: "Er lik",
              operator: ""
            },
            {
              id: "notEqual",
              name: "Er ulik",
              operator: " NOT"
            }
          ]
        }
      }, type: Object
    },
  },
  computed: {
    items: function () {
      let items = [];
      if (this.checkboxes.length > 0 && this.checkboxes[0].group) {
        this.checkboxes.forEach(group => {
          items.push({ header: group.group })
          group.options.forEach(item => {
            items.push(item);
          });
        });
      } else {
        this.checkboxes.forEach(item => {
          items.push(item);
        });
      }
      return items;
    }
  },
  methods: {
    ...mapActions(["setSelectedMaaleParameter", "setFilterValue"]),
    selectModeChanged: function (evt) {
      this.singleSelectOptions.value = evt;
      this.updateFilter(this.value);
    },
    getInfoText: function (parameterName) {
      let optionHelpText = this.options.optionsHelpText.filter((helpText) => {
        return helpText.name === parameterName;
      });
      if (optionHelpText.length > 0) {
        return optionHelpText[0].infoText;
      } else {
        return ''
      }
    },
    filterValues: function (item, queryText, itemText) {
      if (this.options.customLabel) {
        let customLabel = this.options.customLabel(item);
        return customLabel.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      } else {
        return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      }
    },
    removeSelectedValue: function (item) {
      const index = this.value.indexOf(item)
      if (index >= 0) {
        this.value.splice(index, 1)
        this.updateFilter(this.value);
      }
    },
    resetFilter: function () {
      this.value = [];
      this.updateFilter(this.value);
    },
    updateFilter: function (selectedValues) {

      this.options.currentValue = this.value;
      if (this.parameter === "stasjonParameter") {
        this.setSelectedMaaleParameter(JSON.parse(JSON.stringify(this.value)));
      }
      if (selectedValues.length === 0) {
        this.setFilterValue({
          filterFieldName: this.parameter,
          filterQueryString: null
        });
        return;
      }
      if (selectedValues.length > 0) {
        let queryString = this.getQueryString(selectedValues);
        this.setFilterValue({
          filterFieldName: this.parameter,
          filterQueryString: queryString
        });
      }
    },
    getQueryString: function (selectedValues) {
      let queryString = '';
      if (this.options.useLikeOperator) {
        queryString = getQueryStringForMultiselectUsingLikeOperator(selectedValues, {
          parameter: this.parameter,
          filterProperty: this.options.filterProperty,
          operator: this.singleSelectOptions.value.operator
        });
      } else {

        queryString = getQueryStringForMultiselect(selectedValues, {
          parameter: this.parameter,
          operator: this.singleSelectOptions.value.operator,
          skipQuotes: this.options.skipQuotes
        });
      }
      return queryString;
    },
    customLabel (element) {
      if (this.options.customLabel) {
        return this.options.customLabel(element);
      }
      return element;
    }
  },
  created: function () {
    this.$eventHub.$on("reset-all-filters", this.resetFilter);
  }
};
</script>

<style>
</style>

